"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeContext = void 0;
exports.default = ThemeProvider;
exports.useTheme = useTheme;
var _react = _interopRequireWildcard(require("react"));
var _Reader = require("../constants/Reader");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ThemeContext = exports.ThemeContext = /*#__PURE__*/(0, _react.createContext)();
function ThemeProvider(_ref) {
  var {
    children
  } = _ref;
  var [theme, setTheme] = (0, _react.useState)(_Reader.THEME.DEFAULT);
  var [scale, setScale] = (0, _react.useState)(1);
  return /*#__PURE__*/_react.default.createElement(ThemeContext.Provider, {
    value: {
      theme,
      setTheme,
      scale,
      setScale,
      THEME: _Reader.THEME
    }
  }, children);
}
function useTheme() {
  return (0, _react.useContext)(ThemeContext);
}